import { createSlice } from "@reduxjs/toolkit";
import { loadMembershipData } from "./membershipActions";

interface MembershipState {
  loading: boolean;
  membershipData: object | null;
  error: string | unknown;
  success: boolean;
}

const initialState: MembershipState = {
  loading: false,
  membershipData: null,
  error: null,
  success: false,
};

const membershipSlice = createSlice({
  name: "membership",
  initialState,
  reducers: {
    membershipDataRequested: (state) => {
      state.loading = true;
    },
    membershipDataUpdated: (state, action) => {
      state.membershipData = action.payload;
    },
    membershipDataCleared: (state) => {
      state.membershipData = null;
      state.success = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loadMembershipData.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(loadMembershipData.fulfilled, (state, action) => {
      state.loading = false;
      state.membershipData = action.payload;
    });
    builder.addCase(loadMembershipData.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});
export const {
  membershipDataRequested,
  membershipDataUpdated,
  membershipDataCleared,
} = membershipSlice.actions;
export default membershipSlice.reducer;
